module.exports = __webpack_public_path__ + "f7435b1a6cda778779e08965547ece79.ttf";